var map = {
	"./adminIcons/bell.svg": "dd06",
	"./adminIcons/bell_fill.svg": "4902",
	"./adminIcons/building-2.svg": "41cf",
	"./adminIcons/building-2_fill.svg": "bca6",
	"./adminIcons/person.svg": "bb3b",
	"./adminIcons/person_fill.svg": "db71",
	"./consultations/brush.svg": "b3b5",
	"./consultations/mic.svg": "af92",
	"./consultations/paperclip.svg": "5371",
	"./consultations/pharma.svg": "3294",
	"./consultations/pharma_fill.svg": "7213",
	"./consultations/play_rectangle.svg": "f577",
	"./consultations/play_rectangle_fill.svg": "13fb",
	"./consultations/sparkles.svg": "56a1",
	"./consultations/stop_rectangle.svg": "c304",
	"./consultations/stop_rectangle_fill.svg": "d929",
	"./consultations/test-tube-1.svg": "210a",
	"./header/arrowtriangle-compact-down_fill.svg": "97e1",
	"./header/magnifyingglass.svg": "aefd",
	"./login/frame.svg": "b000",
	"./login/logos-fullname.svg": "e822",
	"./login/logos.svg": "5dc5",
	"./login/lux_trust_mobile.svg": "8882",
	"./login/luxtrust.svg": "7372",
	"./menuIcons/Logos.svg": "4b48",
	"./menuIcons/book-vertical.svg": "fc7d",
	"./menuIcons/book-vertical_fill.svg": "9468",
	"./menuIcons/box.svg": "a4e2",
	"./menuIcons/box_fill.svg": "5174",
	"./menuIcons/bubble-checkmark.svg": "82f3",
	"./menuIcons/bubble-checkmark_fill.svg": "e0b9",
	"./menuIcons/bubble.svg": "e7dc",
	"./menuIcons/bubble_fill.svg": "b02a",
	"./menuIcons/calendar-1.svg": "b7eb",
	"./menuIcons/calendar-10.svg": "fb64",
	"./menuIcons/calendar-10_fill.svg": "61c6",
	"./menuIcons/calendar-11.svg": "3284",
	"./menuIcons/calendar-11_fill.svg": "4bdc",
	"./menuIcons/calendar-12.svg": "b422",
	"./menuIcons/calendar-12_fill.svg": "e194",
	"./menuIcons/calendar-13.svg": "3a49",
	"./menuIcons/calendar-13_fill.svg": "e928",
	"./menuIcons/calendar-14.svg": "f7ca",
	"./menuIcons/calendar-14_fill.svg": "37c4",
	"./menuIcons/calendar-15.svg": "7112",
	"./menuIcons/calendar-15_fill.svg": "ec38",
	"./menuIcons/calendar-16.svg": "1eb6",
	"./menuIcons/calendar-16_fill.svg": "6ec8",
	"./menuIcons/calendar-17.svg": "b79c",
	"./menuIcons/calendar-17_fill.svg": "0fb5",
	"./menuIcons/calendar-18.svg": "0ef6",
	"./menuIcons/calendar-18_fill.svg": "96f7",
	"./menuIcons/calendar-19.svg": "887f",
	"./menuIcons/calendar-19_fill.svg": "9e5e",
	"./menuIcons/calendar-1_fill.svg": "e2bb",
	"./menuIcons/calendar-2.svg": "61b1",
	"./menuIcons/calendar-20.svg": "c78a",
	"./menuIcons/calendar-20_fill.svg": "c701",
	"./menuIcons/calendar-21.svg": "a331",
	"./menuIcons/calendar-21_fill.svg": "e9b9",
	"./menuIcons/calendar-22.svg": "159d",
	"./menuIcons/calendar-22_fill.svg": "874f",
	"./menuIcons/calendar-23.svg": "42d1",
	"./menuIcons/calendar-23_fill.svg": "7975",
	"./menuIcons/calendar-24.svg": "f3f3",
	"./menuIcons/calendar-24_fill.svg": "846a",
	"./menuIcons/calendar-25.svg": "94fe",
	"./menuIcons/calendar-25_fill.svg": "0674",
	"./menuIcons/calendar-26.svg": "c060",
	"./menuIcons/calendar-26_fill.svg": "eea2",
	"./menuIcons/calendar-27.svg": "58b9",
	"./menuIcons/calendar-27_fill.svg": "dada",
	"./menuIcons/calendar-28.svg": "e8f9",
	"./menuIcons/calendar-28_fill.svg": "a217",
	"./menuIcons/calendar-29.svg": "5453",
	"./menuIcons/calendar-29_fill.svg": "2b42",
	"./menuIcons/calendar-2_fill.svg": "bf8a",
	"./menuIcons/calendar-3.svg": "4aa6",
	"./menuIcons/calendar-30.svg": "4aa6b",
	"./menuIcons/calendar-30_fill.svg": "2c7d",
	"./menuIcons/calendar-31.svg": "7528",
	"./menuIcons/calendar-31_fill.svg": "412b",
	"./menuIcons/calendar-3_fill.svg": "2133",
	"./menuIcons/calendar-4.svg": "a08f",
	"./menuIcons/calendar-4_fill.svg": "f28a",
	"./menuIcons/calendar-5.svg": "3bed",
	"./menuIcons/calendar-5_fill.svg": "15a2",
	"./menuIcons/calendar-6.svg": "d969",
	"./menuIcons/calendar-6_fill.svg": "6404",
	"./menuIcons/calendar-7.svg": "29ba",
	"./menuIcons/calendar-7_fill.svg": "0ab8",
	"./menuIcons/calendar-8.svg": "0684",
	"./menuIcons/calendar-8_fill.svg": "3cff",
	"./menuIcons/calendar-9.svg": "309c",
	"./menuIcons/calendar-9_fill.svg": "c553",
	"./menuIcons/calendar-arrow-to.svg": "0c44",
	"./menuIcons/calendar_fill.svg": "78f2",
	"./menuIcons/creditcard.svg": "fd91",
	"./menuIcons/creditcard_fill.svg": "83a2",
	"./menuIcons/edit.svg": "b233",
	"./menuIcons/euro.svg": "5450",
	"./menuIcons/euro_fill.svg": "19c1",
	"./menuIcons/gear.svg": "416e",
	"./menuIcons/graduationcap.svg": "3ae4",
	"./menuIcons/graduationcap_fill.svg": "d1cd",
	"./menuIcons/hourglass_3.svg": "10b4",
	"./menuIcons/hourglass_3_fill.svg": "7b38",
	"./menuIcons/id-card.svg": "0476",
	"./menuIcons/id-card_fill.svg": "51b5",
	"./menuIcons/magnifyingglass.svg": "da32",
	"./menuIcons/person-2.svg": "7dcc",
	"./menuIcons/person-2_fill.svg": "9661",
	"./menuIcons/person-plus.svg": "277c",
	"./menuIcons/person-plus_fill.svg": "38a5",
	"./menuIcons/person.svg": "6006",
	"./menuIcons/person_fill.svg": "904f",
	"./navigationIcons/chevron-left.svg": "6665",
	"./navigationIcons/chevron-right.svg": "e30c",
	"./rightBar/allergens.svg": "cc57",
	"./rightBar/antibody.svg": "fb3a",
	"./rightBar/biohazard.svg": "1eca",
	"./rightBar/bone.svg": "7a5a",
	"./rightBar/brain.svg": "bd89",
	"./rightBar/dna.svg": "dfd4",
	"./rightBar/ear.svg": "9d2a",
	"./rightBar/erlenmeyer.svg": "2084",
	"./rightBar/exclamationmark-triangle.svg": "7868",
	"./rightBar/exclamationmark-triangle_fill.svg": "9e93",
	"./rightBar/eye.svg": "d60c",
	"./rightBar/hand_allergy.svg": "f118",
	"./rightBar/heart.svg": "fcee",
	"./rightBar/kidney.svg": "d1ef",
	"./rightBar/lungs.svg": "e913",
	"./rightBar/molecule.svg": "5b4c",
	"./rightBar/people.svg": "765c",
	"./rightBar/person-2.svg": "dd5d",
	"./rightBar/person.svg": "1f01",
	"./rightBar/pill-duo.svg": "9b67",
	"./rightBar/plus.svg": "cfc7",
	"./rightBar/questionmark-diamond.svg": "6284",
	"./rightBar/red-cell.svg": "8b48",
	"./rightBar/ribbon.svg": "d54a",
	"./rightBar/scalpel.svg": "0104",
	"./rightBar/skin.svg": "3ca1",
	"./rightBar/speedometer.svg": "be5e",
	"./rightBar/stomach.svg": "882e",
	"./rightBar/thyroid.svg": "d892",
	"./rightBar/uterus.svg": "5146",
	"./settings/bell.svg": "cc7c",
	"./settings/bell_fill.svg": "892f",
	"./settings/bubble-checkmark.svg": "83b95",
	"./settings/bubble-checkmark_fill.svg": "865d",
	"./settings/building-2.svg": "33f7",
	"./settings/building-2_fill.svg": "148d",
	"./settings/calendar.svg": "e815",
	"./settings/calendar_fill.svg": "6c9f",
	"./settings/creditcard.svg": "0ac0",
	"./settings/creditcard_fill.svg": "7745",
	"./settings/doc-stack.svg": "b683",
	"./settings/doc-stack_fill.svg": "19d5",
	"./settings/hourglass_3.svg": "b757",
	"./settings/hourglass_3_fill.svg": "fc2f",
	"./settings/id-card.svg": "8687",
	"./settings/id-card_fill.svg": "d2cb",
	"./settings/lock.svg": "a565",
	"./settings/lock_fill.svg": "4380",
	"./settings/pencil.svg": "d06f",
	"./settings/person-2.svg": "6e90",
	"./settings/person-2_fill.svg": "17c2",
	"./settings/slider-horizontal-3.svg": "feb6",
	"./settings/slider-horizontal-3_fill.svg": "34ab",
	"./settings/trash.svg": "b5d3",
	"./shareIcons/arrow-clockwise.svg": "ae10",
	"./shareIcons/arrow-down-right.svg": "73a9",
	"./shareIcons/arrow-right.svg": "ef10",
	"./shareIcons/arrowhalf-bidirectional-horizontal.svg": "ab06",
	"./shareIcons/bandage.svg": "1642",
	"./shareIcons/bandage_fill.svg": "ba52",
	"./shareIcons/bold.svg": "2151",
	"./shareIcons/bolt.svg": "9a6a",
	"./shareIcons/building-2_fill.svg": "107c",
	"./shareIcons/calendar-arrow-from.svg": "2e1b",
	"./shareIcons/calendar.svg": "06bd",
	"./shareIcons/checkmark-square.svg": "19f4",
	"./shareIcons/checkmark-square_fill.svg": "2d05",
	"./shareIcons/checkmark.svg": "3146",
	"./shareIcons/chevron-compact-2-down.svg": "5315",
	"./shareIcons/chevron-compact-2-up.svg": "5d0c",
	"./shareIcons/chevron-down.svg": "3b29",
	"./shareIcons/chevron-up.svg": "d932",
	"./shareIcons/clock.svg": "6f9a",
	"./shareIcons/cloud-and-arrow-up_fill.svg": "df44",
	"./shareIcons/doc.svg": "7316",
	"./shareIcons/doc_fill.svg": "8740",
	"./shareIcons/empty-set.svg": "0d1e",
	"./shareIcons/envelope_fill.svg": "ce83",
	"./shareIcons/exclamationmark-triangle_fill.svg": "4879",
	"./shareIcons/eye.svg": "0b84",
	"./shareIcons/hashtag.svg": "622b",
	"./shareIcons/hourglass_2_fill.svg": "6b19",
	"./shareIcons/house_fill.svg": "87e0",
	"./shareIcons/id-card_fill.svg": "72e1",
	"./shareIcons/info-circle.svg": "bc09",
	"./shareIcons/iphone-gen2.svg": "a04c",
	"./shareIcons/italic.svg": "cdd0",
	"./shareIcons/list_bullet.svg": "9ef2",
	"./shareIcons/list_dash.svg": "bcda",
	"./shareIcons/magnifyingglass.svg": "8388",
	"./shareIcons/pencil_fill.svg": "8a68",
	"./shareIcons/person-checkmark.svg": "7830",
	"./shareIcons/person-checkmark_fill.svg": "8a55",
	"./shareIcons/person-plus_fill.svg": "9bf6",
	"./shareIcons/person.svg": "ddfc",
	"./shareIcons/person_fill.svg": "25c3",
	"./shareIcons/phone_fill.svg": "b81d",
	"./shareIcons/play_pause_rectangle.svg": "3e54",
	"./shareIcons/plus.svg": "fc55",
	"./shareIcons/stethoscope.svg": "908a",
	"./shareIcons/three-vertical-dots.svg": "df45",
	"./shareIcons/trash.svg": "d9a6",
	"./shareIcons/underline.svg": "8b1d",
	"./shareIcons/xmark-octagon_fill.svg": "3c5b",
	"./shareIcons/xmark.svg": "a9b6",
	"./task/accounting.svg": "8e40",
	"./task/learning.svg": "be7d",
	"./task/none.svg": "fca9",
	"./task/patient.svg": "4b45",
	"./task/research.svg": "1c0c",
	"./task/staff.svg": "a1c3",
	"./task/stock.svg": "c691",
	"./task/teaching.svg": "ed22"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9c4a";